module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    attrs: {
      "taxonomy": _vm.taxonomy,
      "termId": _vm.termId,
      "categoryName": _vm.categoryName
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcc5634c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/modules/app.vue
// module id = 358
// module chunks = 0